function productTabsInit() {
  const tabs = document.querySelectorAll(".Tabs_common_inner_new");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const tab_id = this.getAttribute("tab_id");
      const parent = this.closest(".Tabs_common_main_new");

      if (!this.classList.contains("active")) {

        parent.querySelectorAll(".Tabs_common_inner_new").forEach(el => {
          el.classList.remove("active");
        });

        parent.querySelectorAll(".tabcontent").forEach(el => {
          el.style.display = "none";
        });

        this.classList.add("active");

        const activeContent = parent.querySelector("." + tab_id + "_open");
        if (activeContent) {
          activeContent.style.display = "block";
        }
      }

      if (window.innerWidth < 749) {
        const activeTab = document.querySelector(".common_tab_new .tablinks.active");

        if (activeTab) {
          activeTab.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
          });
        }
      }
    });
  });
}

productTabsInit();
document.addEventListener("product-tabs:init", productTabsInit);


/* Index_tab_feature_product_slider */
new Swiper('.Index_tab_feature_product_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 40,
  slidesPerGroup: 1,
  slidesPerView: 4,
  watchSlidesProgress: false,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  freeMode: false,
  observer: true,
  observeParents: true,
  mousewheel: {
      forceToAxis: true,  
      releaseOnEdges: false,
      eventsTarget: '.Index_tab_feature_product_slider' 
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }, 
  breakpoints: {
    0: {
      spaceBetween: 24,
      slidesPerView: 1.307
    },
    750: {
      spaceBetween: 12,
      slidesPerView: 2.307
    },
    990: {
      spaceBetween: 24,
      slidesPerView: 3
    },
    1200: {
      spaceBetween: 24,
      slidesPerView: 4
    },
    1440: {
      spaceBetween: 40,
      slidesPerView: 4
    }
  }
});

/* index-icon-with-text-section */
new Swiper('.icon-text-swiper', {
  loop: true,
  autoplay: {
    delay: 0,
  },
  speed: 3500,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerGroup: 1,
  slidesPerView: 6,
  watchSlidesProgress: false,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  freeMode: false,
  observer: true,
  observeParents: true,
  mousewheel: {
      forceToAxis: true,  
      releaseOnEdges: false,
      eventsTarget: '.icon-text-swiper' 
    },
  breakpoints: {
        0: {
          // slidesPerView: 2.73,
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 6,
        },
      },
});

// index-blog-slider
new Swiper('.blogSwiper', {
  loop: false,
  grabCursor: true,
  spaceBetween: 75,
  slidesPerGroup: 1,
  slidesPerView: 4,
  watchSlidesProgress: false,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  freeMode: false,
  observer: true,
  observeParents: true,
  mousewheel: {
      forceToAxis: true,  
      releaseOnEdges: false,
      eventsTarget: '.blogSwiper' 
    },
  breakpoints: {
    0: {
      spaceBetween: 16,
      slidesPerView: 1.250
    },
    750: {
      spaceBetween: 16,
      slidesPerView: 2.307
    },
    990: {
      spaceBetween: 24,
      slidesPerView: 2
    },
    1200: {
      spaceBetween: 24,
      slidesPerView: 3
    },
    1440: {
      spaceBetween: 75,
      slidesPerView: 3
    }
  }
});

// Index-object-instagram-new
new Swiper('.Index_object_instagram_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 50,
  slidesPerGroup: 1,
  slidesPerView: 3.5,
  watchSlidesProgress: false,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  freeMode: false,
  observer: true,
  observeParents: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }, 
  mousewheel: {
      forceToAxis: true,  
      releaseOnEdges: false,
      eventsTarget: '.Index_object_instagram_slider' 
    },
  breakpoints: {
    0: {
      spaceBetween: 16,
      slidesPerView: 1.171
    },
    750: {
      spaceBetween: 16,
      slidesPerView: 2.171
    },
    990: {
      spaceBetween: 24,
      slidesPerView: 2.171
    },
    1200: {
      spaceBetween: 24,
      slidesPerView: 3.6
    },
    1440: {
      spaceBetween: 50,
      slidesPerView: 3.6
    }
  }
});

// function initAccordion() {
//   const questions = document.querySelectorAll(".accordion .question");

//   questions.forEach(question => {
//     question.addEventListener("click", function () {
//       const li = this.closest("li");
//       const accordion = this.closest(".accordion");
//       const answers = accordion.querySelectorAll(".answer");
//       const items = accordion.querySelectorAll("li");

//       if (!li.classList.contains("open")) {
//         // Close all
//         answers.forEach(ans => ans.style.display = "none");
//         items.forEach(item => item.classList.remove("open"));

//         // Open current
//         const nextAnswer = this.nextElementSibling;
//         if (nextAnswer && nextAnswer.classList.contains("answer")) {
//           nextAnswer.style.display = "block";
//         }

//         li.classList.add("open");
//       } else {
//         // Close all
//         answers.forEach(ans => ans.style.display = "none");
//         items.forEach(item => item.classList.remove("open"));
//       }
//     });
//   });
// }

// initAccordion();

/* Accordian Start */
function initCustomAccordion(root) {
    const scope = root || document;
    scope.querySelectorAll(".accordion").forEach(acc => {
        const items = acc.querySelectorAll("li");

        items.forEach(item => {
            if (item.dataset.accordionBound === "true") return;
            item.dataset.accordionBound = "true";

            const question = item.querySelector(".question");
            const answer = item.querySelector(".answer");

            if (!question || !answer) return;

            // Ensure correct default state
            if (item.classList.contains("open")) {
                answer.style.display = "block";
                answer.style.height = "auto";
            } else {
                answer.style.display = "none";
                answer.style.height = 0;
            }

            question.addEventListener("click", () => {
                const isOpen = item.classList.contains("open");

                // Close all other items
                items.forEach(i => {
                    if (i === item) return;
                    i.classList.remove("open");
                    const a = i.querySelector(".answer");
                    if (a) {
                        a.style.height = a.scrollHeight + "px"; // ensure correct closing start
                        requestAnimationFrame(() => {
                            a.style.transition = "height 300ms ease";
                            a.style.height = "0px";
                        });
                        setTimeout(() => {
                            a.style.display = "none";
                            a.style.removeProperty("transition");
                        }, 300);
                    }
                });

                // If the clicked one was open, just close it
                if (isOpen) {
                    item.classList.remove("open");
                    answer.style.height = answer.scrollHeight + "px";
                    requestAnimationFrame(() => {
                        answer.style.transition = "height 300ms ease";
                        answer.style.height = "0px";
                    });
                    setTimeout(() => {
                        answer.style.display = "none";
                        answer.style.removeProperty("transition");
                    }, 300);
                    return;
                }

                // Otherwise, open it
                item.classList.add("open");
                answer.style.display = "block";
                answer.style.height = "auto";              // get natural height
                const endHeight = answer.scrollHeight + "px";
                answer.style.height = "0px";               // restart animation
                requestAnimationFrame(() => {
                    answer.style.transition = "height 300ms ease";
                    answer.style.height = endHeight;
                });
                // Wait until animation finishes, then scroll
                setTimeout(() => {
                    answer.style.height = "auto";
                    answer.style.removeProperty("transition");

                    // ✅ Scroll ONLY if inside Product_meta_collapsible_main_new
                    const container = item.closest(".Product_meta_collapsible_main_new");
                    if (container) {
                      // Scroll to question AFTER opening
                      const offset = 100; // adjust to your header height
                      const y = question.getBoundingClientRect().top + window.pageYOffset - offset;

                      window.scrollTo({
                          top: y,
                          behavior: "smooth"
                      });
                    }
                }, 300)
            });
        });
    });
}

window.initCustomAccordion = initCustomAccordion;
initCustomAccordion(document);
/* Accordian End */

function initChocolateSwiper() {
  document.querySelectorAll('.chocolate-collection-images').forEach(el => {
    if (!el.classList.contains('swiper-initialized')) {
      new Swiper(el, {
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: false,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    }
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', initChocolateSwiper);

// Run when Shopify reloads sections dynamically
document.addEventListener('shopify:section:load', initChocolateSwiper);

document.querySelectorAll('.customer_testimonials_swiper').forEach(function(el) {
  const isChocolateSection = el.closest('.chocolate-collection-testimonial');
  new Swiper(el, {
    loop: false,
    grabCursor: true,
    spaceBetween: 24,
    slidesPerGroup: 1,
    slidesPerView: isChocolateSection ? 4 : 3.5,
    watchSlidesProgress: false,
    draggable: true,
    autoHeight: false,
    watchOverflow: true,
    threshold: 10,
    freeMode: false,
    observer: true,
    observeParents: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: false,
      eventsTarget: el
    },
    breakpoints: isChocolateSection ? {
      0: { spaceBetween: 16, slidesPerView:1.0764 },
      750: { spaceBetween: 16, slidesPerView: 2 },
      990: { spaceBetween: 24, slidesPerView: 3 },
      1200: { spaceBetween: 24, slidesPerView: 4 },
      1440: { spaceBetween: 24, slidesPerView: 4 }
    } : {
      0: { spaceBetween: 16, slidesPerView: 0.796 },
      750: { spaceBetween: 16, slidesPerView: 1.0764 },
      990: { spaceBetween: 24, slidesPerView: 2.0764 },
      1200: { spaceBetween: 24, slidesPerView: 2.0764 },
      1440: { spaceBetween: 24, slidesPerView: 2.0764 }
    }
  });

});